export default __webpack_public_path__ + "static/media/lab-prev.41be6ea4.png";